require("./brokerConvenienceTestCoherenceControlModal.scss");

// @vendors
const React = require("react");
const { connect } = require("react-redux");
const PropTypes = require("prop-types");
const { FormattedText } = require('core/i18n').i18n;
const moment = require('moment');

// @constants
const { DATE_FORMAT_SLASHED_ES, DATE_FORMAT } = require('constants/index');

// @utilities
const { formatDate } = require('utilities/dateHelper');
const { isPrivateEquityTest } = require('mifid/utilities/mifidPrivateEquityHelper');

// @actions
const BrokerConvenienceMiFIDTestActions = require('mifid/actions/brokerConvenienceMiFIDTest');

// @components
const OKModal = require('components/commons/OKModal/OKModal');

// @tagging
const { taggingEventHandled } = require('utilities/taggingEventHandled');
const { PROC_BROKER_CONVENIENCE_TEST } = require('utilities/tagging');

class BrokerConvenienceTestCoherenceControlModal extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { categoryName, subCategoryName } = this.props;
        taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'onOpenModalCoherence','', subCategoryName || categoryName)
    }

    buildRadioContent() {
        const { immBrokerConvenienceMiFIDTest } =  this.props;
        const listContent = immBrokerConvenienceMiFIDTest.get('listAnswerWithCoherence').toJS();
        const content = listContent.map((question) => {
            return (
                <div className="convenience-test-coherence-control__content-incoherence-bold">
                    {question.description}:  {question.previousAnswer.description}
                </div>
            )
        })
        return content;
    }

    buildAccordionContent() {
        const { immBrokerConvenienceMiFIDTest } =  this.props;
        const listContent = immBrokerConvenienceMiFIDTest.get('listAnswerWithCoherence').toJS();

        const content = listContent.map((question, index) => {
            const count = index + 1;
            const previousAnswer = question.previousAnswer.description.replace("shortResponse", "");
            return (
                <div className="convenience-test-coherence-control__content-incoherence">
                   {count}. {question.description}: <strong>{previousAnswer}</strong>
                </div>
            )
        })
        return content;
    }

    buildModalContent() {
        const { isLastStep, immBrokerConvenienceMiFIDTest } =  this.props;
        const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn(['mifidv2','testToEvaluate', 'tipoTest'])

        let rawDate = immBrokerConvenienceMiFIDTest.getIn(['test', 'testToEvaluate', 'lastDateTest'], '');
        if (isPrivateEquityTest(testToEvaluateId)) {
            rawDate = immBrokerConvenienceMiFIDTest.getIn(['listAnswerWithCoherence', 0, 'lastDateTest']);
        }
        const isAccordionControl = immBrokerConvenienceMiFIDTest.get('isAccordionAnswer');
        const content = isAccordionControl ? this.buildAccordionContent() : this.buildRadioContent();
        const date = rawDate
            ? formatDate(moment(rawDate, DATE_FORMAT_SLASHED_ES), DATE_FORMAT)
            : '-'

        const dateKey = isLastStep
            ? 'broker-convenienceMifidTestCoherenceControlDateTextLastStep'
            : 'broker-convenienceMifidTestCoherenceControlDateText';

        const questionKey = isLastStep
            ? 'broker-convenienceMifidTestCoherenceControlQuestionLastStep'
            : 'broker-convenienceMifidTestCoherenceControlQuestion';
        return(
            <div className="convenience-test-coherence-control">
                <div className="convenience-test-coherence-control__content-date">
                    <FormattedText
                        value={dateKey}
                        injectedStrings={[date]}
                    />
                </div>
                {content}
                <div className="convenience-test-coherence-control__content-question">
                    <FormattedText
                        value={questionKey}
                    />
                </div>
            </div>
        );
    }

    handleSecondaryButton() {
        const { isLastStep, showModalForCoherenceControl,
            showConfirmationStep,
            nextQuestion, categoryName, subCategoryName } = this.props;

            taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'onNextQuestionModalCoherence','', subCategoryName || categoryName)

            showModalForCoherenceControl(false);
            if(isLastStep) {
                showConfirmationStep()
            } else {
            nextQuestion()
        }
    }

    handleOnPrimaryButtonClick () {
        const { showModalForCoherenceControl, categoryName, subCategoryName } = this.props;
        taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'onVerifyModalCoherence','', subCategoryName || categoryName)
        showModalForCoherenceControl(false)
    }

    handleOncloseCallback () {
        const { showModalForCoherenceControl, categoryName, subCategoryName } = this.props;
        taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'onCloseModalCoherence','', subCategoryName || categoryName)
        showModalForCoherenceControl(false)
    }

    render(){
        const {
            isLastStep,
            immBrokerConvenienceMiFIDTest,
        } = this.props;
        const showModal = immBrokerConvenienceMiFIDTest.get('showCoherenceModal');
        const secondaryButtonkey = isLastStep
            ? 'broker-convenienceMifidTestCoherenceControlSecondaryButtonTextLastStep'
            : 'broker-convenienceMifidTestCoherenceControlSecondaryButtonText';
        return(
            <OKModal
                title="broker-convenienceMifidTestCoherenceControlTitle"
                titleAlignment="center"
                content={this.buildModalContent()}
                isOpen={showModal}
                footerType="navigation"
                primaryButtonText="broker-convenienceMifidTestCoherenceControlPrimaryButtonText"
                onPrimaryButtonClick={() => this.handleOnPrimaryButtonClick()}
                onCloseCallback={() => this.handleOncloseCallback()}
                secondaryButtonText={secondaryButtonkey}
                onSecondaryButtonClick={() => this.handleSecondaryButton()}
            />
        );
    }
}

BrokerConvenienceTestCoherenceControlModal.propTypes = {
    isLastStep: PropTypes.bool,
    showModalForCoherenceControl: PropTypes.bool,
    immBrokerConvenienceMiFIDTest: PropTypes.object,
    categoryName: PropTypes.string,
    subCategoryName: PropTypes.string,
    showConfirmationStep: PropTypes.func,
    nextQuestion: PropTypes.func,
}

const mapStateToProps = (state) => ({
    immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
});

const mapDispatchToProps = {
    showModalForCoherenceControl: BrokerConvenienceMiFIDTestActions.showModalForCoherenceControl,
    nextQuestion: BrokerConvenienceMiFIDTestActions.moveToNextStep,
    showConfirmationStep: BrokerConvenienceMiFIDTestActions.showConfirmationStep
};

module.exports = connect(
    mapStateToProps,
    mapDispatchToProps
)(BrokerConvenienceTestCoherenceControlModal);
